<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    {{ user()?.displayName ?? user()?.name }}
  </div>
  @if (loading()) {
    <app-loading></app-loading>
  }
  @for (rt of tickets$ | async; track $index) {
    <ion-item lines="none"
      button="true"
      (click)="onTicket(rt)">
      <ion-avatar slot="start">
        @if (rt.preview$ | async; as preview) {
          <img [src]="preview" />
        } @else {
          <ion-icon name="image-outline"></ion-icon>
        }
      </ion-avatar>
      <div class="tw:w-full">
        <span>{{ site()?.name }}</span><br />
        <div class="tw:flex tw:justify-between tw:items-center tw:w-full">
          {{ rt.name | translateTicket | async }}
          <ion-chip [color]="rt.statusColor">
            @if (rt.additionalWork) {
              {{ 'kanban.additionalWorkInfoText' | translate }}
            } @else {
              {{ 'kanban.status.' + rt.status | translate }}
            }
          </ion-chip>
        </div>
        <div class="tw:flex">
          {{ 'kanban.fullHours' | translate }}: {{ rt.hours }}h
          @if (rt.usedTimeInH > 0) {
            {{ 'tickets.usedTime' | translate }}: {{ rt.usedTimeInH }}h
          }
        </div>
      </div>
    </ion-item>
  } @empty {
    <app-no-results></app-no-results>
  }
</app-main-dialog>